import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {NavItem, Button} from 'reactstrap';
import {isMobileOnly as isMobile, isTablet} from 'react-device-detect';

const TabButtonComponent = (props) => {
  return (
    <NavItem className={`tab-button custom-tab text-center d-flex flex-wrap align-items-center ${props.active ? 'active' : ''}`}>
      <Button
        color='link'
        onClick={props.onClick}
        className={`w-100 h-100 ${
          isMobile || (isTablet && props.isPortrait) || props.isSmallResolution ? '' : 'd-flex'
        } justify-content-center align-items-center`}>
        <Image src={props.active ? props.activeIcon : props.icon}
          alt='icon'
          className={`${
            isMobile || (isTablet && props.isPortrait) || props.isSmallResolution ? 'd-block m-auto' : 'align-middle'
          } tab-icon`} />
        <span className={`${isMobile || (isTablet && props.isPortrait) || props.isSmallResolution ? '' : 'align-middle'} tab-title `}>
          {props.title}
        </span>
      </Button>
    </NavItem>
  );
};

export default TabButtonComponent;
